/**
 * Daily Focus Queue v1 — thin client wrapper.
 *
 * Tenant scope is carried by the authenticated session cookie. Never send
 * companyId from the browser.
 */

import { apiRequest } from './apiClient';

function buildQuery(params = {}) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '' || value === false) {
      return;
    }
    search.set(key, String(value));
  });
  const query = search.toString();
  return query ? `?${query}` : '';
}

export async function listFocusQueue({
  type = '',
  includeDismissed = false,
  limit = 15
} = {}) {
  return apiRequest(`/api/focus-queue${buildQuery({
    type,
    includeDismissed: includeDismissed ? 'true' : '',
    limit
  })}`);
}

export async function getFocusQueueCounts({ type = '' } = {}) {
  return apiRequest(`/api/focus-queue/counts${buildQuery({ type })}`);
}

export async function dismissFocusQueueItem(itemKey) {
  return apiRequest('/api/focus-queue/dismiss', {
    method: 'POST',
    body: JSON.stringify({ itemKey })
  });
}

export async function undismissFocusQueueItem(itemKey) {
  return apiRequest(`/api/focus-queue/dismiss/${encodeURIComponent(itemKey)}`, {
    method: 'DELETE'
  });
}
